import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import SearchResultEntity from "../../../../domain/entities/SearchResultEntity";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";
import { SearchShiftsParams } from "../../../../domain/repositories/ShiftRepository";

const SearchShiftsApiImpl = async (params: SearchShiftsParams): Promise<Either<ErrorEntity, SearchResultEntity<ShiftEntity>>> => {
    const { query, page, itemsPerPage, date, sortByNeedAttendance } = params;
    try {
        const dateStr = date.toISOString().split('T')[0];
        let relativeUrl = `/turns/searcher?page=${page}&per_page=${itemsPerPage}&date=${dateStr}`;
        if (query != undefined && query.length > 0) {
            relativeUrl += `&text=${encodeURIComponent(query)}&query=${encodeURIComponent(query)}`;
        }
        relativeUrl += sortByNeedAttendance ? `&sort=need_attention` : `&sort=date`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        
        const shifts = response.turns.map((item: any) => ShiftDto.fromJSON(item));
        
        const result: SearchResultEntity<ShiftEntity> = {
            data: shifts,
            total: response.pagination.total,
            page: response.pagination.current_page,
            itemsPerPage: response.pagination.per_page,
            pages: response.pagination.last_page,
        };
        
        return right(result);
    } catch (e) {
        return left({ code: "Error" });
    }
};

export default SearchShiftsApiImpl;